import { render, staticRenderFns } from "./GenericDialog.vue?vue&type=template&id=4a9a96a7"
import script from "./GenericDialog.vue?vue&type=script&lang=js"
export * from "./GenericDialog.vue?vue&type=script&lang=js"
import style0 from "./GenericDialog.vue?vue&type=style&index=0&id=4a9a96a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports